const PaymentDetails = ()=>{
    return(
        <div>payment details</div>
    )
}

export default PaymentDetails;